<template>
  <div class="container list_prod pt-30">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <h5 class="c-text_title">ショッピングカート</h5>
    <message-area />
    <div class="tile is-ancestor">
      <div class="tile is-9 is-vertical is-parent">
        <div class="tile is-child">
          <cart-item
            :cart-data="carts"
            :handle-input-change="handleInputChange"
            :delete-product-from-cart="deleteProductFromCart"
          />
        </div>
      </div>
      <div class="tile is-parent price-cart">
        <div class="tile is-child">
          <div class="div_right_cart c-bg-grey">
            <div class="div_right_text mb-30">
              <span>合計</span>
              <p id="money">{{ `${sumCart} ${$t('common.ETH')}` }}</p>
            </div>
            <router-link
              :to="{
                name: 'AddressRegistration',
                params: { carts: cartData }
              }"
            >
              <button :disabled="!canSubmit" class="button is-primary buyButton">
                購入手続きへ進む
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" src="./cart-detail.scss">
</style>

<script>
import MessageArea from '@/components/common/message-area/message-area.vue';
import CartItem from '../../../components/cart-item/cart-item';

import {
  getDataCarts,
  changeProductQuantity,
  removeProductInCart,
  removeProductByIds
} from '../../../../../services/cart.service';
import { getProductDetail, getProductStockById } from '../../../../../services/product.service';
import messageUtils from '../../../../../utils/mixins/messageUtils';
import dataTransform from '../../../../../utils/mixins/dataTransform';
import { getProductQuantity } from '../../../../../services/properties.service';

export default {
  name: 'CartDetail',
  components: {
    'message-area': MessageArea,
    'cart-item': CartItem
  },
  mixins: [messageUtils, dataTransform],
  data() {
    return {
      messageId: null,
      errorId: null,
      per_page_bottom: 10,
      carts: []
    };
  },
  computed: {
    sumCart: function() {
      let sum = 0;
      this.carts.forEach(item => {
        if (item.product) {
          sum += item.quantity * item.product.price || 0;
        }
      });
      return this.formatPrice(sum);
    },
    cartData: function() {
      const result = [];
      this.carts.forEach(item => {
        if (item.product) {
          result.push(item);
        }
      });
      return result;
    },
    canSubmit: function() {
      let checkQuantity = true;
      this.cartData.forEach(cart => {
        const productQuantity = getProductQuantity(cart.product, cart.propId);
        if (cart.quantity > productQuantity) {
          checkQuantity = false;
        }
      });
      return checkQuantity && this.cartData.length > 0;
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  async mounted() {
    this.getCartData();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async getCartData() {
      this.loading++;
      const { status, result } = await getDataCarts();
      console.log(`cart-detail.vue - (132) - `, result);
      if (status) {
        this.carts = result.data.carts;
        const removeIds = [];
        const promiseForCartItem = async (cart, index) => {
          const productId = Number(cart.productId);
          const newCart = cart;
          const response = await getProductDetail(productId);
          console.log(`cart-detail.vue - (168) - `, response);
          if (response.status && (response.result && response.result.data && response.result.data.status)) {
            const product = response.result.data;
            newCart['product'] = product;
            this.$set(this.carts, index, newCart);
            const productQuantity = getProductQuantity(product, cart.propId);
            if (productQuantity === -1) this.updateMessage(0, { messageId: 'EF2153_Content' });
            else if (cart.quantity > productQuantity) this.updateMessage(0, { messageId: 'EA2028_Content' });
          } else {
            this.updateMessage(0, { messageId: 'EF2146_Content' });
            removeIds.push(productId);
            // const removeResponse = await removeProductInCart(productId);
            // console.log(`cart-detail.vue - (178) - `, removeResponse);
          }
          return newCart;
        };

        const promises = this.carts.map((cart, index) => promiseForCartItem(cart, index));
        const r = await Promise.all(promises);
        console.log(`cart-detail.vue - (187) - `, r);
        if (removeIds.length > 0) {
          console.log(`cart-detail.vue - (194) - `, removeIds);
          const res = await removeProductByIds(removeIds);
          console.log(`cart-detail.vue - (194) - `, res);
          this.$parent.$emit('updateCart');
        }
      } else {
        this.updateMessage(status, result);
      }
      this.loading--;
    },
    async handleInputChange(changeValue, itemIndex) {
      this.clearMessage();
      this.loading++;
      const cartItem = this.carts[itemIndex];
      const productId = cartItem.productId;
      try {
        // Refresh product quantity from sidechain to have the latest update
        cartItem.product.properties = await getProductStockById(cartItem.product.id);
        cartItem.product.quantity = cartItem.product.properties.stock_num;
      } catch (err) {
        this.loading--;
        console.log('Cannot fetch product properties from sidechain, using old data', err);
      }

      const productRemain = getProductQuantity(cartItem.product, cartItem.propId);
      const { status, result } = await changeProductQuantity(productId, cartItem.propId, changeValue, productRemain);
      this.loading--;
      if (status) {
        cartItem.quantity += changeValue;
        this.$set(this.carts, itemIndex, cartItem);
        this.$parent.$emit('updateCart');
      }
      this.updateMessage(status, result);
    },
    async deleteProductFromCart(itemIndex) {
      this.clearMessage();
      const cartItem = this.carts[itemIndex];
      const productId = cartItem.productId;
      const propId = cartItem.propId;
      this.loading++;
      let from_cart = true;
      const { status, result } = await removeProductInCart(productId, propId, from_cart);
      if (status) {
        this.carts.splice(itemIndex, 1);
        this.$parent.$emit('updateCart');
      }
      this.updateMessage(status, result);
      this.loading--;
    },
    handleResize() {
      // console.log(7777, window.innerWidth);
      if (window.innerWidth >= 1500) {
        this.per_page_bottom = 10;
      } else if (window.innerWidth < 1500 && window.innerWidth >= 1120) {
        this.per_page_bottom = 7;
      } else if (window.innerWidth < 1120 && window.innerWidth >= 800) {
        this.per_page_bottom = 5;
      } else {
        this.per_page_bottom = 5;
      }
    }
  }
};
</script>
